export const VIEW_OPTION_PATHS = {
  CORE: 'core',
  SPECIALIZED_UNITS: 'specialized_units',
  INTERVENTIONS: 'interventions',
  LAUNCH: 'launch',
  PREPARE: 'prepare',
  PROGRAM_ADOPTION: 'program_adoption',
  MONITOR: 'monitor',
  SETUP: 'setup',
}

export const PROGRAM_PERMISSION_MAPPING = {
  // techincally K8 is k5SelDigital + mspDigital
  // but simplify this to only check a single permission flag per program:
  HS: 'highSchool',
  HS_MONITOR: 'highSchool',
  K8: 'k5SelDigital',
  K8_MONITOR: 'k5SelDigital',
  SELA: 'sela',
  BPU: 'bpuDigital',
  CPU: 'cpuDigital',
  DWB: 'dwbp_enabled',
}

export const SNAPSHOTS_NAME_MAP = {
  HS: 'onboardingSnapshot',
  HS_MONITOR: 'progressMonitoringSnapshot',
  K8: 'onboardingSnapshot',
  K8_MONITOR: 'progressMonitoringSnapshot',
}

const now = new Date()
const calendarYear = now.getUTCFullYear()
const april16BoundaryUtc = new Date(Date.UTC(calendarYear, 3, 16, 7, 0, 0, 0))
const may25BoundaryUtc = new Date(Date.UTC(calendarYear, 4, 25, 7, 0, 0, 0))
const june25BoundaryUtc = new Date(Date.UTC(calendarYear, 5, 25, 7, 0, 0, 0))
const june25Timestamp = june25BoundaryUtc.toISOString()
let schoolYearLabel

if (now < april16BoundaryUtc) {
  schoolYearLabel = `${calendarYear - 1}-${calendarYear}`
} else {
  schoolYearLabel = `${calendarYear}-${calendarYear + 1}`
}

const schoolYearStartTest =
  now < may25BoundaryUtc ? calendarYear - 1 : calendarYear
const schoolYearStart =
  now < june25BoundaryUtc ? calendarYear - 1 : calendarYear
const tierLabelTest = `${schoolYearStartTest}-${schoolYearStartTest + 1}`
const tierLabel = `${schoolYearStart}-${schoolYearStart + 1}`

export const PLAYBOOK_STEP_MAP = {
  flowName: 'K8 Implementation Guide',
  name: schoolYearLabel,
  publishDate: june25Timestamp,
  tierLabel,
  tierLabelTest,
}

export const previousSchoolYearLabel = (label, delta = -1) => {
  const [a, b] = label.split('-').map(Number)
  return `${a + delta}-${b + delta}`
}

export const formatManageUsersLinkLabel = name => `Manage Users at ${name}`
export const formatReportLinkLabel = name => `See Report about ${name}`
export const formatUnitKey = index => `Unit ${index + 1}`
export const formatUserSetupLinkLabel = name =>
  `See Users without classes at ${name}`

export const getProgramSnapshot = (programKey, snapshots) => {
  const programPermissionKey = PROGRAM_PERMISSION_MAPPING[programKey]
  if (!programPermissionKey) {
    throw new Error(`unsupported program: ${programKey}`)
  }

  let match = snapshots?.find(
    snap => snap?.permissionsPrograms?.[programPermissionKey],
  )

  // Backward compatibility: existing DWB onboarding snapshots may still be
  // keyed under `sela` while we migrate to `dwbp_enabled`.
  if (!match && programKey === 'DWB') {
    match = snapshots?.find(snap => snap?.permissionsPrograms?.sela)
  }

  return match
}

export const getTooltip = (programSnapshot, location) => {
  return programSnapshot?.tooltips?.find(t => t.tooltipLocation === location)
}
